import axios from 'axios';

export default class ResetPasswordService {
  public requestReset(email: string): Promise<boolean> {
    return new Promise((resolve) => {
      axios
      .post('api/public/account/reset-password/init', email, {
        headers: {
          'content-type': 'text/plain',
        },
      })
      .then(() => {
        resolve(true);
      })
      .catch(() => {
        resolve(false);
      });
    });
  }

  public finishReset(keyAndPassword: any): Promise<boolean> {
    return new Promise((resolve) => {
    axios
      .post('api/public/account/reset-password/finish', keyAndPassword)
      .then(() => {
        resolve(true);
      })
      .catch(() => {
        resolve(false);
      });
    });
  }

  public getPasswordPolicies(key: string): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!/^[a-zA-Z0-9-]+$/.test(key)) {
        reject(new Error('Invalid key format'));
        return;
      }
      const url = `api/public/account/users/${String(key)}/settings/password-policies`;
      axios
      .get(url)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
    });
  }

  public getUserInfo(key: string): Promise<any> {
    return new Promise( (resolve, reject) => {
      if (!/^[a-zA-Z0-9-]+$/.test(key)) {
        reject(new Error('Invalid key format'));
        return;
      }
      const url = `api/public/account/users/${String(key)}`;
      axios
      .get(url)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
    });
  }
}
